export const BOOKING_CODE_REGEX = /[^A-Za-z0-9]/g;
